import * as React from 'react';
import { Button, Box, createStyles } from '@mantine/core';
import { IconChevronUp } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface SeeMoreLessButtonProps {
    opened?: boolean;
    minimal?: boolean;
    onClick?: () => void;
}

const useStyles = createStyles((theme) => ({
    openIcon: {
        transform: 'rotate(0deg)',
        transition: 'all 0.1s ease'
    },
    rotated: {
        transform: 'rotate(180deg)'
    },
    root: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        '&:hover': {
            background: theme.colors.gray[0]
        },
        '.mantine-ActionIcon-root': {
            flexGrow: 1
        }
    }
}));

export const SeeMoreLessButton: React.FC<SeeMoreLessButtonProps> = ({ opened, onClick = () => {}, minimal }) => {
    const { t } = useTranslation('components', { keyPrefix: 'buttons' });
    const { classes, cx } = useStyles();

    return minimal ? (
        <Box className={classes.root} onClick={onClick}>
            <IconChevronUp
                size={20}
                className={cx(classes.openIcon, {
                    [classes.rotated]: !opened
                })}
            />
        </Box>
    ) : (
        <Button
            variant="outline"
            onClick={onClick}
            rightIcon={
                <IconChevronUp
                    size={20}
                    className={cx(classes.openIcon, {
                        [classes.rotated]: !opened
                    })}
                />
            }
        >
            {t(!opened ? 'seeMore' : 'seeLess')}
        </Button>
    );
};
